import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CarouselStyle = styled(Stack)(() => ({
  flexGrow: 1
}));

export const Navigation = styled(Stack)(() => ({
  ".left-navigation-container": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "0.6875rem"
  },
  ".right-navigation-container": {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "0.5rem"
  },
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  width:"100%"
}));
